exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-general{height:100%;max-height:600px;min-height:600px;max-width:100%;margin:0}.success--text{color:green}.error--text{color:red}", ""]);

// exports
